import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const APP_ROLE_CREATE_RESOURCE = "app-role" as const;
export const APP_ROLE_CREATE_API_PATH = `/v1/${APP_ROLE_CREATE_RESOURCE}` as const;

export type AppRoleCreateBody =
  paths[typeof APP_ROLE_CREATE_API_PATH]["post"]["requestBody"]["content"]["application/json"];
export type AppRoleCreateResponse =
  paths[typeof APP_ROLE_CREATE_API_PATH]["post"]["responses"][200]["content"]["application/json"];

export const useAppRoleCreateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<AppRoleCreateResponse, Error, AppRoleCreateBody>({
    mutationFn: async (appRole: AppRoleCreateBody) => {
      const response = await alphartisApiAxios.post<AppRoleCreateResponse>(APP_ROLE_CREATE_API_PATH, appRole);
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [APP_ROLE_CREATE_RESOURCE],
      });
    },
  });
};
